import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatIDR } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Sparkles, Lock } from "lucide-react";

const INITIAL_BALANCE = 5_000_000;

export default function JoinPage() {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleJoin = async (e) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) {
      toast.error("Isi nama dulu ya");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/players/join", { name: trimmed });
      localStorage.setItem("player", JSON.stringify(data));
      toast.success(`Selamat datang, ${data.name}!`);
      navigate("/play");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Gagal bergabung");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="casino-theme flex items-center justify-center p-4 sm:p-8">
      <div className="w-full max-w-md">
        {/* Glow header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-red-500/10 border border-red-500/30 mb-6">
            <Sparkles className="w-3.5 h-3.5 text-red-400" />
            <span className="text-xs uppercase tracking-widest text-red-300">
              Simulasi Edukasi Anti Judol
            </span>
          </div>
          <h1
            className="heading text-5xl sm:text-6xl mb-3"
            style={{
              background: "linear-gradient(180deg, #FFE55C 0%, #FFD700 50%, #C9A300 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            GACOR777
          </h1>
          <p className="text-sm text-stone-400 leading-relaxed max-w-xs mx-auto">
            Mesin slot keberuntungan. Saldo awal{" "}
            <span className="digital text-base">{formatIDR(INITIAL_BALANCE)}</span>{" "}
            menanti Anda.
          </p>
        </div>

        {/* Form card */}
        <div className="glass-card gold-border p-6 sm:p-8">
          <form onSubmit={handleJoin} className="space-y-5">
            <div>
              <label className="block text-xs uppercase tracking-widest text-amber-300/80 mb-2">
                Nama Pemain
              </label>
              <Input
                data-testid="join-name-input"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Masukkan nama Anda"
                maxLength={30}
                autoFocus
                disabled={loading}
                className="bg-black/40 border-amber-500/30 text-white placeholder:text-stone-500 h-12 text-base focus-visible:ring-amber-500/50"
              />
            </div>

            <Button
              type="submit"
              data-testid="join-submit-button"
              disabled={loading}
              className="spin-button w-full h-14 text-lg uppercase tracking-wider"
            >
              {loading ? "Loading..." : "Mulai Main"}
            </Button>
          </form>

          <div className="mt-6 pt-6 border-t border-amber-500/20">
            <div className="flex items-start gap-3 text-xs text-stone-400 leading-relaxed">
              <div className="w-1 h-1 rounded-full bg-amber-400 mt-1.5 flex-shrink-0" />
              <p>
                Aplikasi ini adalah <span className="text-amber-300 font-semibold">simulasi</span>{" "}
                tanpa uang sungguhan. Tujuannya membongkar trik di balik judol.
              </p>
            </div>
          </div>
        </div>

        {/* Admin link */}
        <div className="text-center mt-6">
          <button
            data-testid="open-admin-link"
            onClick={() => navigate("/admin")}
            className="inline-flex items-center gap-2 text-xs text-stone-500 hover:text-amber-400 transition-colors"
          >
            <Lock className="w-3 h-3" />
            Masuk sebagai Admin
          </button>
        </div>
      </div>
    </div>
  );
}
